import homepageMeta from '../../utils/seo_utils/homepage_seo_util';
import postMeta from '../../utils/seo_utils/post_seo_util';
import videoMeta from '../../utils/seo_utils/video/video_seo_util';
import videoIndexMeta from '../../utils/seo_utils/video/video_index_seo_util';
import videoPlaylistMeta from '../../utils/seo_utils/video/video_playlist_seo_util';
import categoryMeta from '../../utils/seo_utils/category_seo_util';
import tagMeta from '../../utils/seo_utils/tag_seo_util';
import personMeta from '../../utils/seo_utils/mcp/person_seo_util';
import productMeta from '../../utils/seo_utils/ibd/product_seo_util';
import personIndexMeta from '../../utils/seo_utils/mcp/person_index_seo_util';
import productIndexMeta from '../../utils/seo_utils/ibd/product_index_seo_util';
import magazineArchivePageMeta from '../../utils/seo_utils/magazine_archive_seo_util';
import bestWorkplacesForInnovatorsMeta from '../../utils/seo_utils/bwi/best_workplaces_for_innovators_seo_util';
import mostCreativePeopleMeta from '../../utils/seo_utils/mcp/most_creative_people_seo_util';
import mostCreativePeopleCommunityMeta from '../../utils/seo_utils/mcp/most_creative_people_community_seo_util';
import micYearPageMeta from '../../utils/seo_utils/mic/mic_year_page_seo_util';
import mic2020YearPageMeta from '../../utils/seo_utils/mic/mic2020_year_page_seo_util';
import micSectorPageMeta from '../../utils/seo_utils/mic/mic_sector_page_seo_util';
import companyPageMeta from '../../utils/seo_utils/mic/company_page_seo_util';
import ibdYearPageMeta from '../../utils/seo_utils/ibd/ibd_year_page_seo_util';
import giftGuidePageMeta from '../../utils/seo_utils/gift_guide/gift_guide_page_seo_util';
import giftPageMeta from '../../utils/seo_utils/gift_guide/gift_seo_util';
import companyIndexPageMeta from '../../utils/seo_utils/mic/company_index_seo_util';
import authorMeta from '../../utils/seo_utils/author_seo_util';
import queer50Meta from '../../utils/seo_utils/queer50_seo_util';
import searchMeta from '../../utils/seo_utils/search_seo_util';
import wpPageMeta from '../../utils/seo_utils/wp_page_seo_util';
import staticPageMeta from '../../utils/seo_utils/static_page_seo_util';
import newslettersPreferencesPageMeta from '../../utils/seo_utils/newsletters_preferences_page_seo_util';
import sitemapIndexPageMeta from '../../utils/seo_utils/sitemap_index_page_seo_util';
import sitemapPostPageMeta from '../../utils/seo_utils/sitemap_post_page_seo_util';
import pianoPageMeta from '../../utils/seo_utils/piano_page_seo_util';

export default function(state = {}, action) {
  const { store, type } = action;

  const typeMap = {
    POSTPAGE_LOADED() {
      const currentState = store.getState();
      return postMeta(currentState);
    },

    PIANO_PAGE_LOADED() {
      const currentState = store.getState();
      return pianoPageMeta(currentState);
    },

    PREVIEW_POSTPAGE_LOADED() {
      const currentState = store.getState();
      return postMeta(currentState);
    },

    HOMEPAGE_LOADED() {
      const currentState = store.getState();
      return homepageMeta(currentState);
    },

    CATEGORY_PAGE_LOADED() {
      const currentState = store.getState();
      return categoryMeta(currentState);
    },

    TAG_PAGE_LOADED() {
      const currentState = store.getState();
      return tagMeta(currentState);
    },

    PERSON_PAGE_LOADED() {
      const currentState = store.getState();
      return personMeta(currentState);
    },

    PRODUCT_PAGE_LOADED() {
      const currentState = store.getState();
      return productMeta(currentState);
    },

    BEST_WORKPLACES_PAGE_LOADED() {
      const currentState = store.getState();
      return bestWorkplacesForInnovatorsMeta(currentState);
    },

    MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      const currentState = store.getState();
      return mostCreativePeopleMeta(currentState);
    },

    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      const currentState = store.getState();
      return mostCreativePeopleCommunityMeta(currentState);
    },

    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED() {
      const currentState = store.getState();
      return mostCreativePeopleCommunityMeta(currentState);
    },

    PERSON_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      return personIndexMeta(currentState);
    },

    PERSON_INDEX_SECTION_PAGE_LOADED() {
      const currentState = store.getState();
      return personIndexMeta(currentState);
    },

    PRODUCT_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      return productIndexMeta(currentState);
    },

    PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      const currentState = store.getState();
      return productIndexMeta(currentState);
    },

    AUTHOR_PAGE_LOADED() {
      const currentState = store.getState();
      return authorMeta(currentState);
    },

    QUEER50_PAGE_LOADED() {
      const currentState = store.getState();
      return queer50Meta(currentState);
    },

    SEARCH_PAGE_LOADED() {
      const currentState = store.getState();
      return searchMeta(currentState);
    },

    WP_PAGE_LOADED() {
      const currentState = store.getState();
      return wpPageMeta(currentState);
    },

    STATIC_PAGE_LOADED() {
      const currentState = store.getState();
      return staticPageMeta(currentState);
    },

    HTML_SITEMAP_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      return sitemapIndexPageMeta(currentState);
    },

    HTML_SITEMAP_POST_PAGE_LOADED() {
      const currentState = store.getState();
      return sitemapPostPageMeta(currentState);
    },

    MAGAZINE_ARCHIVE_LOADED() {
      const currentState = store.getState();
      return magazineArchivePageMeta(currentState);
    },

    MIC_YEAR_PAGE_LOADED() {
      const currentState = store.getState();
      return micYearPageMeta(currentState);
    },

    MIC_2020_YEAR_PAGE_LOADED() {
      const currentState = store.getState();
      return mic2020YearPageMeta(currentState);
    },

    MIC_SECTOR_PAGE_LOADED() {
      const currentState = store.getState();
      return micSectorPageMeta(currentState);
    },

    COMPANY_PAGE_LOADED() {
      const currentState = store.getState();
      return companyPageMeta(currentState);
    },

    COMPANY_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      return companyIndexPageMeta(currentState);
    },

    COMPANY_INDEX_SECTION_PAGE_LOADED() {
      const currentState = store.getState();
      return companyIndexPageMeta(currentState);
    },

    INNOVATION_BY_DESIGN_PAGE_LOADED() {
      const currentState = store.getState();
      return ibdYearPageMeta(currentState);
    },

    GIFT_GUIDE_PAGE_LOADED() {
      const currentState = store.getState();
      return giftGuidePageMeta(currentState);
    },

    GIFT_PAGE_LOADED() {
      const currentState = store.getState();
      return giftPageMeta(currentState);
    },

    VIDEO_PAGE_LOADED() {
      const currentState = store.getState();
      return videoMeta(currentState);
    },

    PLAYLIST_PAGE_LOADED() {
      const currentState = store.getState();
      return videoPlaylistMeta(currentState);
    },

    VIDEO_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      return videoIndexMeta(currentState);
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED() {
      const currentState = store.getState();
      return newslettersPreferencesPageMeta(currentState);
    }
  };
  if (typeMap[type]) {
    return typeMap[type](action);
  }

  return state;
}
